import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import AuthShell from "../components/AuthShell";
import { api, errMsg } from "../lib/api";

export function Recuperar() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try { await api.post("/auth/forgot-password", { email }); setSent(true); }
    catch (err) { toast.error(errMsg(err)); }
    finally { setLoading(false); }
  };

  return (
    <AuthShell testid="recuperar-page" overline="Contraseña" title="Recupera tu acceso.">
      {sent ? (
        <p data-testid="recuperar-sent" className="text-zinc-300 leading-relaxed">
          Si existe una cuenta con <strong className="text-white">{email}</strong>, te llegará un enlace para crear una
          nueva contraseña. Es válido por 1 hora.
        </p>
      ) : (
        <form onSubmit={submit} data-testid="recuperar-form" className="space-y-5">
          <div><label className="field-label">Correo de tu cuenta</label>
            <input data-testid="recuperar-email" type="email" required className="input-field" value={email}
              onChange={(e) => setEmail(e.target.value)} /></div>
          <button data-testid="recuperar-submit" type="submit" disabled={loading} className="btn-lilac w-full justify-center">
            {loading ? "Enviando…" : "Enviarme el enlace"}
          </button>
        </form>
      )}
      <Link to="/ingresar" className="block text-sm text-zinc-500 hover:text-[#C9A25E] mt-6">← Volver a entrar</Link>
    </AuthShell>
  );
}

export function Restablecer() {
  const [params] = useSearchParams();
  const [pw, setPw] = useState({ password: "", confirm: "" });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    if (pw.password !== pw.confirm) { toast.error("Las contraseñas no coinciden"); return; }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token: params.get("token") || "", password: pw.password });
      toast.success("Contraseña actualizada. Ya puedes entrar ✦");
      navigate("/ingresar");
    } catch (err) { toast.error(errMsg(err)); }
    finally { setLoading(false); }
  };

  return (
    <AuthShell testid="restablecer-page" overline="Contraseña" title="Crea una nueva contraseña.">
      <form onSubmit={submit} data-testid="restablecer-form" className="space-y-5">
        <div><label className="field-label">Nueva contraseña (mínimo 8 caracteres)</label>
          <input data-testid="restablecer-password" type="password" minLength={8} required className="input-field"
            value={pw.password} onChange={(e) => setPw({ ...pw, password: e.target.value })} /></div>
        <div><label className="field-label">Repite la contraseña</label>
          <input data-testid="restablecer-confirm" type="password" minLength={8} required className="input-field"
            value={pw.confirm} onChange={(e) => setPw({ ...pw, confirm: e.target.value })} /></div>
        <button data-testid="restablecer-submit" type="submit" disabled={loading} className="btn-lilac w-full justify-center">
          {loading ? "Guardando…" : "Guardar contraseña"}
        </button>
      </form>
    </AuthShell>
  );
}
